<template>
  <div>
    <div v-if="display" class="hub-error-overlay primary darken-1 min-height-100 max-height-100 flex-shrink-0 flex-grow-0 d-flex flex-column align-center text-center pt-6 px-0" :class="platform">
      <hub-app-bar hide-title title="Auth" :class="platform"></hub-app-bar>
      <img src="assets/hub-logo-vert-rev.svg" class="hub-logo" />
      <v-spacer></v-spacer>
      <div class="px-6">
        <p class="text-h5 white--text">{{title}}</p>
        <p class="text-body-1 white--text" v-if="message" v-html="message"></p>
        <p class="text-body-1 white--text" v-if="showContactUs">If you need help contact us at <a class="white--text text-truncate" href="mailto:support@the-hub.app" target="_blank">support@the-hub.app</a></p>
        <v-btn v-if="button" large dark color="secondary" rounded elevation="0" class="mt-8" v-text="button.label" @click="button.action"></v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </div>
  </div>
</template>

<script>
import HubAppBar from "@/components/HubAppBar";

export default {
  components: {
    HubAppBar,
  },
  props: {
    platform: {
      type: String,
      default: () => "web",
    },
    fullscreen: Boolean,
  },
  data: () => ({
    display: false,
    status: "",
    title: "",
    message: "",
    showContactUs: false,
    button: null
  }),
  methods: {
    reset() {
      this.display = false;
      this.status = "";
      this.title = "";
      this.message = "";
      this.showContactUs = false;
      this.button = null;
    },
    show({ status = "", title = "", message = "", showContactUs = false, button } = {}) {
      this.status = status;
      this.title = title;
      this.message = message;
      this.showContactUs = showContactUs;
      this.button = button;
      this.display = true;
    },
    hide() {
      this.display = false;
    }
  },
};
</script>

<style lang="scss">
div.hub-error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: env(safe-area-inset-top) !important;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;

  img.hub-logo {
    flex-grow: 0;
    flex-shrink: 0;
    width: 180px;
  }

  .hub-app-bar-container {
    &.macintosh {
      .hub-app-bar-content {
        padding-left: 76px;
      }
    }

    // &.windows {
    //   padding-top: 32px !important;

    //   .hub-app-bar {
    //     padding-top: 32px !important;
    //   }
    // }
  }

  .app-bar-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    font-size: 18px;
    color: white;
  }
}
</style>
